import { defineSettingsScreen } from '@heidi/runtime/shell';

/**
 * Declares the Dictate settings screen through the shell.
 */
export const dictateSettingsScreen = defineSettingsScreen({
  id: 'dictate',
  section: 'personal',
  order: 5,
  load: () =>
    import('../ui/settings/dictate/DictateSettings').then((module) => ({
      default: module.DictateSettings,
    })),
  builds: 'all',
});
